// extracted by mini-css-extract-plugin
export default {"card":"CardsCarousel_card__wy6Pn","title":"CardsCarousel_title__CVpr0","category":"CardsCarousel_category__VqkZD","imagecatogiry":"CardsCarousel_imagecatogiry__bP+sR"};